<template>
  <div id="app">
    <!-- 全局加载方法 -->
    <!-- <van-overlay
      z-index="999"
      :show="loading"
      class-name="page-load-box"
    >
      <div class="loadbox">
        <van-loading
          size="50px"
          color="#1989fa"
          text-color="#1989fa"
          vertical
        >加载中...</van-loading>
      </div>
    </van-overlay>-->
    <router-view />
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import {
  setNavStatus,
  getLoginStatus,
  getUserInfo,
  opneLoginPane,
  setUser
} from "@/utils/app";
export default {
  name: "App",
  // computed: {
  //   ...mapState(["loading"]),
  // },
  created() {
    // console.log(this.loading);
    //定义app返回方法
    window.setUserInfo = this.setUserInfo;
    window.setLocation = this.setLocation;
    window.setIsLogin = this.setIsLogin; // 获取登录状态
    window.loginOut = this.loginOut;
    window.addEventListener("load", this.getRem(750, 100));
    window.addEventListener("resize", this.getRem(750, 100));
  },
  mounted() {
    // 判断是否在微信打开
    // var ua = navigator.userAgent.toLowerCase(); //获取判断用的对象
    // if (ua.match(/MicroMessenger/i) == "micromessenger") {
    //   this.setInWx(true);
    //   //在微信中打开
    // } else {
    //   this.setInWx(false);
    // }
    var u = navigator.userAgent;
    var isAndroid = u.indexOf("zsweb") > -1 && u.indexOf("android") > -1; //android终端
    var isIOS = !!u.indexOf("zsweb") > -1 && u.indexOf("ios") > -1; //ios终端
    console.log("是否在app", isIOS);
    if (localStorage.getItem("noPubilsh")) {
      localStorage.removeItem("noPubilsh");
    }
    if (isIOS) {
      //获取登录状态
      this.setInIOS(true);
      getLoginStatus();
    } else if (isAndroid) {
      this.setInAndroid(true);
      getLoginStatus();
    } else {
      this.setInIOS(false);
      this.setInAndroid(false);
    }
    this.getRem(750, 100);
    window.onresize = () => {
      this.getRem(750, 100);
    };
  },
  methods: {
    ...mapMutations(["setInWx", "setInIOS", "setInAndroid"]),
    //根据html的宽定font-size 的大小
    // fontSize() {
    //   let w = document.documentElement.offsetWidth;
    //   let n = 20 * (w / 357) > 40 ? 40 + "px" : 20 * (w / 357) + "px";
    //   document.documentElement.style.fontSize = n;
    //   console.log("狂赌", document.documentElement.style.fontSize);
    // },
    //页面自适应
    getRem(pwidth, prem) {
      let html = document.getElementsByTagName("html")[0];
      let oWidth =
        document.body.clientWidth || document.documentElement.clientWidth;
      html.style.fontSize = (oWidth / pwidth) * prem + "px";
      console.log(html.style.fontSize);
    },
    // ...mapMutations(["setInWx", "setInIOS", "setInAndroid"]),
    setPayResult: function(data) {
      console.log(data, "setPayResult");
      setTimeout(() => {
        console.log(data, "setPayResult");
      }, 5000);
    },
    setUserInfo: function(data) {
      console.log("app登录信息", JSON.parse(data).data.webTenId);
      // this.$bus.$emit("token", JSON.parse(data).data.token);
      setUser(data);
      window.sessionStorage.setItem("userinfo", JSON.stringify(data));
      window.localStorage.setItem("token", JSON.parse(data).data.token);
      window.localStorage.setItem("webTenId", JSON.parse(data).data.webTenId);
    },
    setLocation: function(data) {
      setLocalStorage({
        iosloca: data
      });
    },
    setIsLogin: function(data) {
      console.log("是否登录", data);
      console.log(localStorage.getItem("noPubilsh"));

      if (data == 1) {
        //已登录
        return getUserInfo();
      } else {
        //未登录
        // opneLoginPane();
        window.localStorage.removeItem("token");
        if (localStorage.getItem("webTenId") == undefined) {
          window.localStorage.removeItem("webTenId");
        }
      }
    },
    loginOut: function() {
      window.localStorage.clear();

      // },
    }
  }
};
</script>

<style>
* {
  margin: 0;
  padding: 0;
  list-style: none;
}
html,
body {
  max-width: 460px;
  height: 100%;
  margin: 0 auto;
}
#app {
  height: 100%;
  /* width: 100%; */
}
@font-face {
  font-family: "iconfont"; /* Project id 2764218 */
  src: url("//at.alicdn.com/t/font_2764218_u3781nbfrv.woff2?t=1652237349435")
      format("woff2"),
    url("//at.alicdn.com/t/font_2764218_u3781nbfrv.woff?t=1652237349435")
      format("woff"),
    url("//at.alicdn.com/t/font_2764218_u3781nbfrv.ttf?t=1652237349435")
      format("truetype");
}
</style>
